import { useMemo } from 'react';

import { useAuthSessionContext } from '@context/authSession';
import { useAuthStoreContext, isLearnerOrAlumni } from '@context/authStore';

import { useTenantSettings } from '@hooks/TenantSettings';

import { useIsHighSchool } from '@customHooks/useIsHighSchool';

import { RESULTS_READY_STATUS } from '@constants';

import { GatherPersonalInfo } from '@components/GatherPersonalInfo';
import { Loader } from '@components/Loader';

import HighSchoolLandingPage from './HighSchoolLanding';
import MiddleSchoolLandingPage from './MiddleSchoolLanding';

export const LandingPage = () => {
  const { isLoading: isLoadingDiscoveryUser } = useAuthSessionContext();
  const { userData, currentAccess, isLoadingUser: isLoadingGusUser } = useAuthStoreContext();
  const { data: tenantSettings, isLoading: isLoadingTenantSettings } = useTenantSettings(
    currentAccess?.tenant?.tenantId ?? '',
  );
  const isHighSchool = useIsHighSchool();

  const userRole = currentAccess.tenant?.permission?.role;
  const isLearner = isLearnerOrAlumni(userRole);

  const isLoadingUserData = useMemo(
    () => isLoadingDiscoveryUser || isLoadingGusUser || isLoadingTenantSettings,
    [isLoadingDiscoveryUser, isLoadingGusUser, isLoadingTenantSettings],
  );

  const resultsReady =
    userData?.productData?.some((data) => {
      let assessmentsStatus;

      if (data.product === 'discovery') {
        assessmentsStatus = data.data.assessmentsStatus;

        return (
          assessmentsStatus?.summit === RESULTS_READY_STATUS ||
          assessmentsStatus?.snapshot === RESULTS_READY_STATUS ||
          assessmentsStatus?.snippet === RESULTS_READY_STATUS
        );
      }

      return false;
    }) ?? false;

  const userWithResultsReady = !isLoadingUserData && resultsReady;

  const handleOnSave = () => {
    window.location.reload();
  };

  if (isLoadingUserData) {
    return <Loader />;
  }

  if (!userData?.profile?.graduationYear && isLearner) {
    return <GatherPersonalInfo isOpenGatherPersonalInfo onSave={handleOnSave} />;
  }

  if (isHighSchool) {
    return (
      <HighSchoolLandingPage
        userData={userData}
        tenantSettings={tenantSettings}
        userWithResultsReady={userWithResultsReady}
      />
    );
  }

  return (
    <MiddleSchoolLandingPage
      userData={userData}
      tenantSettings={tenantSettings}
      userWithResultsReady={userWithResultsReady}
    />
  );
};
